import {
  AfterViewInit,
  ChangeDetectionStrategy, 
  Component, 
  Input,
  Output,
  OnChanges, 
  ViewEncapsulation,
  EventEmitter
} from '@angular/core';
import { ICardEmp } from '@knz/util';
 

@Component({
  selector: 'card-emp',
  exportAs: 'cardEmp',
  templateUrl: './card-emp.component.html',
  host: { '[class.card-emp]': 'true' },
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CardEmpComponent implements AfterViewInit, OnChanges { 
  @Input() data: ICardEmp = {};
  @Output() itemClickEvent = new EventEmitter<any>();
 
 
  get photo(){
    let result="";
    if(this.data!=undefined && this.data.photo!=undefined && this.data.photo!=null && this.data.photo!=""){
      result= this.data.photo;
    }
    return result;
  }

  constructor() {}
 

  ngAfterViewInit() { 
  }

  ngOnChanges() { 
  }

  
  cardClick() { 
    this.itemClickEvent.emit(this.data);
  }
}
